import { Instance, types } from 'mobx-state-tree'

export const Settings = types.model('Settings', {
  key: '',
  value: types.frozen(),
})

export type ISettingsModel = Instance<typeof Settings>
